var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"red"},[_vm._v(_vm._s(_vm.overTime == 0 ? ' 0 秒 ' : _vm.day + '天'  + _vm.hour + '小时' + _vm.minute + '分' + _vm.second + '秒'))])}
var staticRenderFns = []

export { render, staticRenderFns }